module.exports = __webpack_public_path__ + "img/icon-nav-to-dark-mode.f81a3999.svg";